import React from "react";

const PageNotFound = () => (
  <div className="container">
    <h1> 404 error Page not found</h1>
  </div>
);

export default PageNotFound;
